<div class="sidenav" tabindex="1" [ngClass]="{'edit-mode': editMode}">
  <div class="search-container">
    <input (input)="searchSessionStates()" [(ngModel)]="session_search" class="process-search"
      matTooltip="Search pages by name" placeholder="Search pages..."/>
    <mat-icon (click)="session_search='';searchSessionStates()"
      [ngClass]="{'clear-disabled': session_search.length < 1}"
      class="process-search-clear">clear
    </mat-icon>
  </div>
  @for (item of session_results; track item.id) {
    <li class="mat-tree-node menu-node"> <!--session state-->
      <a [routerLink]="item.attributes.url"
      (click)="closeSidenav()">{{item.attributes.name}}</a>
    </li>
  }
  @if (session_results && session_results.length > 0) {
    <mat-divider style="margin:10px;"></mat-divider>
  }

  @if (pinnedItems) {
    <static-menu-tree [staticFolders]="pinnedItems"></static-menu-tree>
  }

  @if (topLevelFolderNode) {
    <dragdrop-tree [node]="topLevelFolderNode"></dragdrop-tree>
  }

  @if (staticFolders) {
    <static-menu-tree [staticFolders]="staticFolders"></static-menu-tree>
  }


  @if (appScope.isNotMobile && !restricted) {
    <div (click)="show_plant = !show_plant;"
      class="mat-tree-node parent-folder-node static">
      <button class="folder-toggle static-folder">
        <i [ngClass]="{'chevron-up': show_plant , 'chevron-down' : !show_plant }"
        class="chevron-down" role="button"></i>
        <span>Plant Menu</span>
      </button>
    </div>
  }

  @if (show_plant && !restricted) {
    <mat-list class="sidetree" style="overflow-y: visible;">
      <div class="search-container">
        <input (input)="searchProcesses()" [(ngModel)]="process_search" class="process-search"
          matTooltip="Please enter at least 3 characters" placeholder="search processes..."/>
        <mat-icon (click)="process_search='';searchProcesses()" [ngClass]="{'clear-disabled': process_search.length < 1}"
          class="process-search-clear">clear
        </mat-icon>
      </div>
      @for (item of search_results; track item.id) {
        <treenode [item]="item" class="search-result-node"></treenode>
      }
      @if (search_results && search_results.length > 0) {
        <mat-divider style="margin:10px;"></mat-divider>
      }
      @if (!appScope.isNotMobile) {
        @for (item of appScope.mobile_sidenav; track $index) {
          <mat-list-item class="mobile_sidenav">
            @if (item.angular_page && item.link) {
              <a [routerLink]="item.link">{{item.name}}</a>
            }
          </mat-list-item>
        }
      }
      @if (plantData.process_focus?.id) {
        <div class="row active-account-row">
          <treenode [item]="appScope.processTreeDataDict[plantData.process_focus.id]"
          class="process-focus-node"></treenode>
          <div class="active-account-indicator">Active</div>
        </div>
      }
      @if (selected_plant) {
        <treenode [item]="appScope.processTreeDataDict[selected_plant.id]" class="selected-process-node"></treenode>
      }
      @if (reports) {
        @for (item of reports; track item.id) {
          <treenode [item]="appScope.processTreeDataDict[item.id]" class="report-node"></treenode>
        }
      }
    </mat-list>
  }
</div>
